import React from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const BenefitsTable = ({ headers }) => {
  const { eligibilityCheckData } = useSelector(
    (state) => state.eligibilityCheck
  );

  const items = eligibilityCheckData?.benefits || [];

  const formatValue = (benefit, isUsed = false) => {
    const key = isUsed ? "usedMoney" : "allowedMoney";
    const unsignedKey = "allowedUnsignedInt";

    if (benefit[key]) {
      return `${benefit[key].value} ${benefit[key].currency}`;
    }
    if (!isUsed && benefit[unsignedKey] !== undefined) {
      return `${benefit[unsignedKey]}%`;
    }
    return "";
  };

  return (
    <div className="mt-3 border-success p-1 border rounded">
      <div className="fs-10 p-2">Benefits Details</div>

      {items?.length > 0 ? (
        <div className="p-2">
          <Table responsive bordered className="mb-0 p-2 rounded-sm">
            <thead>
              <tr>
                <th style={{ width: "70%" }} className="text-start ps-3 fs--1">
                  {headers.main}
                </th>
                {headers.subHeaders.map((header, index) => (
                  <th
                    key={index}
                    style={{ width: "10%" }}
                    className="text-center fs-10"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody style={{ border: "1px solid var(--falcon-border-color)" }}>
              {items.map((item, index) => (
                <React.Fragment key={index}>
                  {/* Main Benefit Row */}
                  <tr className="header-benfits">
                    <td className="text-start ps-3">
                      <div className="d-flex flex-column">
                        <h5 className="text-success fw-500 fs-10 mb-0">
                          {item?.category?.coding?.[0]?.display || item?.name}
                        </h5>
                        <span className="text-600 fw-500 fs-11">
                          {item?.description}
                        </span>
                      </div>
                    </td>
                    <td className="text-center text-capitalize fs-11">
                      {item?.network?.coding?.[0]?.code || "-"} Network
                    </td>
                    <td className="text-center text-capitalize fs-11">
                      {item?.unit?.coding?.[0]?.code || "-"}
                    </td>
                    <td className="text-center text-capitalize fs-11">
                      {item?.term?.coding?.[0]?.code || "-"}
                    </td>
                  </tr>

                  {/* Nested Benefits */}
                  <tr>
                    <td colSpan={4} className="p-0">
                      <Table responsive className="mb-0" hover>
                        <thead>
                          <tr>
                            <th style={{ width: "80%" }} className="fs--1"></th>
                            {headers.nestedHeaders.map((header, idx) => (
                              <th
                                key={idx}
                                style={{ width: "10%" }}
                                className="text-center fs-10"
                              >
                                {header}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody className="nested-table-body">
                          {item?.benefit?.map((benefit, benefitIndex) => {
                            const code =
                              benefit?.type?.coding?.[0]?.code?.replace(
                                /-/g,
                                " "
                              );
                            const displayName =
                              code?.toLowerCase() === "benefit"
                                ? "Benefit (Maximum benefit allowed.)"
                                : code || "Benefit";
                            return (
                              <tr key={benefitIndex}>
                                <td
                                  className={`fs-11 ps-3 ${code?.toLowerCase() !== "benefit"
                                    ? "text-capitalize"
                                    : ""
                                    }`}
                                >
                                  {displayName}
                                </td>
                                <td
                                  className="fs-11 text-center"
                                  style={{
                                    backgroundColor:
                                      "var(--falcon-warning-bg-subtle)",
                                  }}
                                >
                                  {formatValue(benefit)}
                                </td>
                                <td
                                  className="fs-11 text-center"
                                  style={{
                                    backgroundColor:
                                      "var(--falcon-success-bg-subtle)",
                                  }}
                                >
                                  {formatValue(benefit, true)}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </td>
                  </tr>
                  <tr className="spacer-row">
                    <td colSpan={4} style={{ height: "2rem" }}></td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="w-100 py-3 d-flex justify-content-center border mb-3">
          No data to display
        </div>
      )}
    </div>
  );
};

BenefitsTable.defaultProps = {
  headers: {
    main: "",
    subHeaders: ["Network", "Unit", "Term"],
    nestedHeaders: ["Allowed", "Used"],
  },
};

export default BenefitsTable;
